import React , {useState , useEffect} from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import { getSponsorPackageSalesReport,getPayInTransactionReportsExcel ,getPaidPackageList } from '../../api/login/Login'
import { useParams } from 'react-router-dom'
import { Formik, Form, Field } from 'formik';
import { ToastContainer } from 'react-toastify'
import { message, Pagination ,Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx'; 
import Loadar from '../../common/loader/Loader'
import CustomInputField from '../../common/CustomInputField'
import { baseUrlImage } from '../../baseUrl';

const breadCrumbsTitle = {
        id: "1",
        title_1: 'Master',
        title_2:  'Sponsor Package Sales',
      }


const SponsorPackageSalesReport = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [packageData, setPackageData] = useState([])
    const [count , setCount] = useState(10)
      const [data, setData] = useState(null);
      const [loading , setLoading] = useState(false)
    const [formKey, setFormKey] = useState(0);
    const [totalAmount , setTotalAmount] = useState(0)
    const [totalCount , setTotalCount] = useState(0)
    const [resetKey , setResetKey] = useState(false)
    const defaultInitialValues = {
        package_id :''
    };
    const resetValues = {
       package_id :''
    };
    const [initialValues, setInitialValues] = useState(defaultInitialValues);
 

    

     

        const handleReset = (resetForm) => {
            resetForm();
            setInitialValues(resetValues);
            setFormKey(prev => prev + 1); 
            setCurrentPage(1)
            setResetKey((pre)=>!pre)
            // getDmtTxnData(0); 
        };

        const handleSubmit = (values) => {
            
            setCurrentPage(1)
            setInitialValues(values)
            setResetKey((pre)=>!pre)
            // Add your API call here
        };

        const onChangeVal = (page) => {
            setResetKey((pre)=>!pre)
            setCurrentPage(page);
           
        };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getSponsorPackageSalesReport({ 
        page: currentPage, 
        count,
        ...initialValues
      
      });
      if (res && res.data) {
        setData(res?.data);
        setTotalAmount(res?.totalAmount)
        setTotalCount(res?.totalCount)
      } else {
        setData(null);
        setTotalAmount(0)
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      message.error('Failed to fetch transaction data. Please try again.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };
   

      
     const getPackageData = async () => {
          const res = await getPaidPackageList()
          setPackageData(res?.data) }  
  
          useEffect(()=>{
         getPackageData()
          },[])

    const downloadExcel = async () => {
      try {
        setLoading(true);
        const res = await getPayInTransactionReportsExcel({
          ...initialValues,
         
        });
        
        if (res && res.data && res.data?.length > 0) {
       const dataForExcel = res.data.map((item, i) => ({
        "Sr. No": i + 1,
        "Created At": item?.createdAt,
        "Merchant Order ID": item?.merchantOrderId,
        "Order ID": item?.orderId,
        "Opening Balance": item?.o_bal ?? '--',
        "Amount": item?.amount ?? '--',
        "Charges": item?.charges ?? '--',
        "Tax on Charges": item?.taxOnCharge ?? '--',
        "Final Amount": item?.final_amount ?? '--',
        "Closing Balance": item?.c_bal ?? '--',
        "Status":
          item?.status === '1'
            ? 'Pending'
            : item?.status === '2'
            ? 'Success'
            : item?.status === '3'
            ? 'Failed'
            : item?.status === '4'
            ? 'Refund'
            : 'Unknown',
        "User Name": item?.user_name,
        "User Mobile": item?.userMobileNo,
        "User Merchant Code": item?.user_merchant_code,
      }));
  
          const ws = XLSX.utils.json_to_sheet(dataForExcel);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "PayInTrasactionReport");
          XLSX.writeFile(wb, `PayInTrasactionReport ${new Date().toLocaleDateString()}.xlsx`);
        } else {
          message.error('No data available to export!');
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        message.error('Failed to download Excel. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    //   const responseEnquiry = async (id) => {
    //     setLoading(true); // Start loader before API call
    //     try {
    //         const res = await getPayInReportsEnquiry(id);
           
    //         if (res?.data?.statusCode == "200") {
    //             message.success(res?.data?.message || res?.message );
                
    //         } else if (res?.data?.statusCode == "300") {
    //             message.info(res?.message || res?.data?.message );
               
    //         } else {
    //             message.error(res?.message || res?.data?.message);
                
    //         }
    //     } catch (error) {
    //         console.error("Error in payment enquiry:", error);
    //         message.error("An error occurred while processing your request");
    //     } finally {
    //         setResetKey((pre)=>!pre)
    //         setLoading(false); 
    //     }
    // };


  useEffect(()=>{
    getData()
  },[resetKey , currentPage])

  return (
    <>
    { loading && <Loadar/> }
      <ToastContainer />

    
    <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
    
    {/* // Filter Option // */}
    <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} Search</b></h4>
                            </div>
                            <Formik
                                  key={formKey}
                                  initialValues={initialValues}
                                  onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ values, handleChange, errors, touched, resetForm }) => (
                                    <Form className="tbl-captionn">
                                        <div className="row">
                                                <div className="col-xl-4 mb-3">

                                                        <select className="form-select" aria-label="Default select example" name="package_id"
                                                           value={values.package_id}
            onChange={handleChange} 
                                                            
                                                            >
                                                            <option>Open this select Package</option>
                                                            {packageData && packageData?.map((item, index) => (
                                                                <option key={index} value={item._id}>{item.package_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="d-flex justify-content-start">
                                                    <button className="btn btn-primary me-2" type="submit">
                                                        <i className="fas fa-search"></i> Search
                                                    </button>
                                                    <btn className="btn btn-secondary" type="button" onClick={() => handleReset(resetForm)}>
                                                        <i className="fas fa-refresh"></i> Reset
                                                    </btn>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/* // filter option end here  */}


    {/* // table section  */}
    {data?.length > 0 ? (
        <>
         <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} List</b></h4>
                                        <div className='d-flex'>
                                           
                                            {/* <button onClick={downloadExcel} className='btn btn-primary border border-white'> <DownloadOutlined /> Download Excel</button> */}
                                        </div>
                                      

                                    </div>
                                       {/* <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{totalAmount || 0}</b></h3>
                                </div> */}
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer"> 
    <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
                                            <thead>
                                                <tr role="row">
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Sr. No
                                                    </th>
                                                     <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Created Date
                                                    </th>
                                                     <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Expiry Date
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Package Name
                                                    </th>
                                                      <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Purchase Count
                                                    </th>
                                                       <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Assign Count
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Merchant Code
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Name
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Mobile
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Services
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        MRP
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Employee Name: activate to sort column ascending" style={{ width: '203.45px' }}>
                                                        Sale Rate
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Tax
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Contact Number: activate to sort column ascending" style={{ width: '161.675px' }}>
                                                        Type
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Contact Number: activate to sort column ascending" style={{ width: '161.675px' }}>
                                                        Duration
                                                    </th>
                                                    <th className="sorting text-center" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Contact Number: activate to sort column ascending" style={{ width: '161.675px' }}>
                                                        Duration Type
                                                    </th>
                                                    <th className="sorting text-center" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Contact Number: activate to sort column ascending" style={{ width: '161.675px' }}>
                                                        Icon image
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                               
                                                {data?.map((item, i) => (
                                                    <tr role="row" className="odd" style={{ cursor: "pointer" }} key={i}>
                                                        <td>{i + 1 + count * currentPage}</td> {/* Correct serial number */}
                                                        <td>{item?.createdAt}</td>
                                                        <td>{item?.expiryDate}</td>
                                                        <td>{item?.package_name}</td>
<td>{item?.purchased_count}</td>
<td>{item?.assign_count}</td>
                                                        
                                                        <td>{item?.refer_id}</td>
                                                        <td>{item?.user_name}</td>
                                                        <td>{item?.user_mobile}</td>
                                                        <td>
                                                            {item?.services?.map((childItem, index) => (
                                                                <small key={index}>{childItem}</small>
                                                            ))}
                                                        </td>
                                                        <td>{item?.mrp}</td>
                                                        <td>{item?.amount}</td>
                                                        <td>{item?.tax}</td>
                                                        <td>{item?.tax_type}</td>
                                                        <td>{item?.duration}</td>
                                                        <td>{item?.duration_type}</td>
                                                        <td>
                                                            <img
                                                                style={{ width: "100px" }}
                                                                src={`${baseUrlImage}${item?.icon_url}`}
                                                                alt="Package Icon"
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
</div>

                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                        Total {totalCount} entries
                                    </div>
                                    <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                        <Pagination
                                            total={totalCount}
                                            current={currentPage}
                                            onChange={onChangeVal}
 
                                        />
                                    </div>
                                </div>
                            </div>
                          
                        </div>

                    </div>

                </div >
            </section>
        </>
        ) : (
          <div className="text-center mt-4">
            <h3>No data available</h3>
          </div>
        )}
       {/* // table section  */}
    </>
  )
}

export default SponsorPackageSalesReport